import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker temporarily disabled to prevent caching issues
// Will be re-enabled after users have updated
if ('serviceWorker' in navigator) {
  // Unregister existing service workers to clear cache
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('🗑️ Service Worker unregistered for update');
    }
  });
  console.log('ℹ️ Service Worker disabled - forcing fresh content');
}

// Handle PWA install prompt (especially for Android)
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('🔔 PWA Install prompt available!');
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later
  deferredPrompt = e;
  
  // Don't show automatically - wait for user interaction
  // The browser will show its own UI or user can use menu
  console.log('💡 PWA can be installed via browser menu or install button');
});

// Track if app was successfully installed
window.addEventListener('appinstalled', () => {
  console.log('🎉 PWA was installed successfully!');
  deferredPrompt = null;
});
